module.exports = __webpack_public_path__ + "img/lecture.3892f875.png";